export const getUserPreferences = <T>() => {
  let userPreferences: T | undefined;
  const preferences = window.localStorage.getItem("preferences");
  if (preferences) {
    userPreferences = JSON.parse(preferences) as T;
  }
  return userPreferences;
};

export const setUserPreferences = <T>(preferences?: T) => {
  if (preferences) {
    window.localStorage.setItem("preferences", JSON.stringify(preferences));
  } else {
    window.localStorage.removeItem("preferences");
  }
};
